export const fiscalCouvertForm = {
	editOfPlace: "Editar cover fiscal de {{ placeName }}",
	fields: {
		code: {
			label: "SKU",
			placeholder: "Ingrese el SKU",
		},
		NCM: {
			label: "NCM",
			placeholder: "Ingrese el NCM",
		},
		CEST: {
			label: "CEST",
			placeholder: "Ingrese el CEST",
		},
		taxProfile: {
			label: "Perfil fiscal",
		},
		taxGroup: {
			label: "Grupo fiscal",
		},
	},
};
